"use client";
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect } from "react";

/* eslint-disable @typescript-eslint/no-unsafe-call */
declare global {
  interface Window {
    Intercom: any;
  }
}

type Args = {
  launchChat?: boolean;
  message?: string;
};

export const openIntercom = ({ launchChat = true, message }: Args = {}): void => {
  if (typeof window === "undefined" || !window.Intercom) {
    console.warn("Intercom is not loaded");
    return;
  }
  window?.Intercom("update", { hide_default_launcher: false });

  /**
   * launchChat indicates that the bubble was hidden previously.
   * Add a listener to shut down again when then dialog is closed.
   */
  if (launchChat || message) {
    window?.Intercom("show");
    if (message) {
      window?.Intercom("showNewMessage", message);
    }
    window?.Intercom("onHide", () => window?.Intercom("update", { hide_default_launcher: true }));
  }
};

export const ShowIntercom: React.FC = () => {
  /**
   * We now hide Intercom chat bubble by default.
   * Show it on marketing pages by default without opening the dialog.
   */
  const intercomLoaded = typeof window !== "undefined" && Boolean(window.Intercom);
  useEffect(() => {
    const tryOpenIntercom = setTimeout(() => {
      openIntercom({ launchChat: false });
    }, 2000);
    return () => clearTimeout(tryOpenIntercom);
  }, [intercomLoaded]);
  return null;
};
